export default __webpack_public_path__ + "static/media/discipline-education.02a0642c.svg";